import IAppState from "../models/IAppState"
import ActionType from "../models/ActionType"
import { writeBool, writeString, writeJSON, removeKey, STORAGE_KEYS } from "./persistence"


export default function reducer(
    state: IAppState, action: ActionType): IAppState {

    switch (action.type) {
        case 'OK_DIALOG_OPEN_FULL_UPDATE':
            return {
                ...state,
                okDialog: {
                    title: action.title,
                    text: action.text,
                    open: action.open,
                }
            }
        case 'OK_DIALOG_OPEN_UPDATE':
            return {
                ...state,
                okDialog: {
                    ...state.okDialog,
                    open: action.open,
                }
            }
        case 'OK_DIALOG_TITLE_UPDATE':
            return {
                ...state,
                okDialog: {
                    ...state.okDialog,
                    title: action.title,
                }
            }
        case 'OK_DIALOG_TEXT_UPDATE':
            return {
                ...state,
                okDialog: {
                    ...state.okDialog,
                    title: action.text,
                }
            }
        case 'OK_DIALOG_RESET_AND_HIDE':
            return {
                ...state,
                okDialog: {
                    open: false,
                    title: "",
                    text: "",
                }
            }
        case 'CASINO_SEARCH_TEXT_UPDATE':
            writeString(STORAGE_KEYS.casinoSearchText, action.searchText);
            return {
                ...state,
                casinoSearch: {
                    ...state.casinoSearch,
                    searchText: action.searchText,
                }
            }
        case 'CASINO_SORT_FIELD_TYPE_UPDATE':
            writeString(STORAGE_KEYS.casinoSortFieldType, String(action.sortFieldType));
            return {
                ...state,
                casinoSearch: {
                    ...state.casinoSearch,
                    sortFieldType: action.sortFieldType,
                }
            }
        case 'AUTH_LOGIN_SUCCESS':
            writeJSON(STORAGE_KEYS.authUser, action.user);
            return {
                ...state,
                auth: state.auth ? {
                    ...state.auth,
                    authUser: action.user,
                    isAuthenticated: true,
                    isLoading: false,
                } : state.auth,
            }
        case 'AUTH_LOGOUT':
            removeKey(STORAGE_KEYS.authUser);
            return {
                ...state,
                auth: state.auth ? {
                    ...state.auth,
                    authUser: null,
                    isAuthenticated: false,
                    isLoading: false,
                } : state.auth,
            }
        case 'AUTH_SET_LOADING':
            return {
                ...state,
                auth: state.auth ? {
                    ...state.auth,
                    isLoading: action.isLoading,
                } : state.auth,
            }
        case 'USER_POINTS_SET':
            return {
                ...state,
                userPoints: action.points,
            }
        case 'USER_POINTS_CLEAR':
            return {
                ...state,
                userPoints: null,
            }
        case 'CLIENT_CONFIG_SET':
            return {
                ...state,
                clientConfig: action.config,
            }
        case 'HOME_FAVORITES_ONLY_SET':
            writeBool(STORAGE_KEYS.homeFavoritesOnly, action.value);
            return {
                ...state,
                homeFavoritesOnly: action.value,
            }
        case 'FAVORITE_TOGGLE':
            return {
                ...state,
                favoriteOverrides: {
                    ...state.favoriteOverrides,
                    [action.casinoId]: action.isFavorite,
                },
            }
        case 'PWA_UPDATE_AVAILABLE':
            return {
                ...state,
                pwa: { ...state.pwa, updateAvailable: action.value },
            }
        case 'PWA_OFFLINE_READY':
            return {
                ...state,
                pwa: { ...state.pwa, offlineReady: action.value },
            }
        case 'PWA_ONLINE_STATUS_CHANGED':
            return {
                ...state,
                pwa: { ...state.pwa, isOnline: action.isOnline },
            }
        default:
            return state;
    }
}